<template>
   <div class="content-wrapper" style="background: rgb(237, 240, 242);">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-5">
               <h1>
                  Dashboard
               </h1>
            </div>
            <div class="col-xs-7 mandatoryDiv">
               <span class="letter-right"> Last Refresh Time: {{refresh_datetime}}</span>
               <a class="btn btn-sm btn-add" @click="refreshDashboard"><i class="fa fa-refresh"></i> Refresh</a>
            </div>
         </div>
      </section>
      <section class="content">

         <!--Subscription Graph Start-->
         <SubscribePinsGraphForFlex v-if="renderComponent" />
         <!--Subscription Graph End-->

      </section>
   </div>
</template>
<script>
   import axios from 'axios'
   import SubscribePinsGraphForFlex from "@/components/dashboardComponents/SubscribePinsGraphForFlex.vue";
   export default {
      name: "Dashboard",
      components: {
         SubscribePinsGraphForFlex,
      },
      data() {
         return {
            renderComponent : true,
            refresh_datetime : '',      
         }
      },
      props: {
         msg: String,
      },
      created(){
         this.com_isTVReseller();
         loader.show();
         setTimeout(function(){
            loader.hide(); 
         }, 1000);
      },
      methods: {

         refreshDashboard() {
            this.forceRerender();
         },

         forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;
            this.$nextTick(() => {
               // Add the component back in
               this.renderComponent = true;
            });
         }
      },
      mounted: function() {
         
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>